import { defineFilterSpec, enumField, multiField, text } from '@/lib/api/filter-spec';

import type { CustomerActivityLogFilterFormValues, CustomerActivityLogFilters } from './types';

/** Single declaration of the Activity Log filters, shared by api/drawer/page. `type` is a
 *  multi-select (joined to a comma string on the wire); date/time bounds pass through as strings
 *  (`enumField` strips falsy). `search` participates only in the query params. */
const spec = defineFilterSpec<CustomerActivityLogFilters, CustomerActivityLogFilterFormValues>([
  text('search'),
  multiField('type'),
  enumField('logDateFrom'),
  enumField('logDateTo'),
  enumField('logTimeFrom'),
  enumField('logTimeTo'),
]);

export const customerActivityLogToListQuery = spec.toListQuery;
export const customerActivityLogToDefaults = spec.toDefaults;
export const customerActivityLogToFilters = spec.toFilters;
export const customerActivityLogHasActiveFilters = spec.hasActiveFilters;
